import { render, staticRenderFns } from "./EspondiloartritesAxialSummary.vue?vue&type=template&id=475f483f&scoped=true&"
import script from "./EspondiloartritesAxialSummary.vue?vue&type=script&lang=js&"
export * from "./EspondiloartritesAxialSummary.vue?vue&type=script&lang=js&"
import style0 from "./EspondiloartritesAxialSummary.vue?vue&type=style&index=0&id=475f483f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475f483f",
  null
  
)

export default component.exports